import React, {ReactNode} from "react";
import {Box, ButtonBase, Typography} from "@mui/material";
import {alpha, useTheme} from "@mui/material/styles";
import {Book, Dns, FactCheck, HowToReg, NoteAlt, Psychology, ReportProblem, VerifiedUser} from "@mui/icons-material";
import {useNavigate} from "react-router-dom";
import {Page, PageHeader} from "../../../components/kit";

const BASE = "/app/admin/config";

const SECTIONS: { to: string, title: string, description: string, icon: ReactNode }[] = [
	{to: `${BASE}/param`, title: "Parámetros", description: "Valores globales de la aplicación: horarios, cadencias, plantillas por defecto…", icon: <Dns/>},
	{to: `${BASE}/user`, title: "Usuarios y permisos", description: "Quién entra y con qué roles.", icon: <HowToReg/>},
	{to: `${BASE}/ai-config`, title: "Inteligencia artificial", description: "Proveedor y modelo para escanear facturas.", icon: <Psychology/>},
	{to: `${BASE}/template`, title: "Plantillas", description: "Plantillas de documentos y correos.", icon: <Book/>},
	{to: `${BASE}/wiki`, title: "Wiki del sistema", description: "Páginas de ayuda internas.", icon: <NoteAlt/>},
	{to: `${BASE}/quality/finding`, title: "No conformidades e incidentes", description: "Registro del sistema de gestión, con acciones y eficacia.", icon: <ReportProblem/>},
	{to: `${BASE}/quality/access-review`, title: "Revisión de accesos", description: "Revisión periódica de usuarios y permisos.", icon: <FactCheck/>},
	{to: `${BASE}/quality/role-assignment`, title: "Roles del sistema de gestión", description: "Designaciones de dirección, responsables, calidad y auditoría, con su historial.", icon: <VerifiedUser/>},
];

/** Portada de configuración (#13893): las secciones como tarjetas, en lugar de una página vacía. */
export const ConfigPage = () => {
	const navigate = useNavigate();
	const theme = useTheme();
	return (
		<Page>
			<PageHeader title="Configuración" subtitle="Parámetros, usuarios, plantillas y registros del sistema de gestión."/>
			<Box sx={{display: "grid", gridTemplateColumns: {xs: "minmax(0, 1fr)", sm: "repeat(2, minmax(0, 1fr))", lg: "repeat(3, minmax(0, 1fr))"}, gap: 2}}>
				{SECTIONS.map(s => (
					<ButtonBase key={s.to} onClick={() => navigate(s.to)} sx={{
						display: "flex", alignItems: "flex-start", justifyContent: "flex-start", gap: 2, p: 2.5, textAlign: "left",
						borderRadius: 3, border: "1px solid", borderColor: "divider", bgcolor: "background.paper",
						transition: "border-color .15s", "&:hover": {borderColor: "primary.main"},
					}}>
						<Box sx={{
							width: 40, height: 40, borderRadius: 2, display: "grid", placeItems: "center", flexShrink: 0,
							bgcolor: alpha(theme.palette.primary.main, 0.1), color: "primary.main",
						}}>{s.icon}</Box>
						<Box sx={{minWidth: 0}}>
							<Typography variant="subtitle2" fontWeight={700}>{s.title}</Typography>
							<Typography variant="body2" color="text.secondary">{s.description}</Typography>
						</Box>
					</ButtonBase>
				))}
			</Box>
		</Page>
	);
};
